<div class="modal-header border-b border-solid border-base-2 px-6 py-4">
    <h2 class="modal-title text-title-2 text-text-primary font-semibold" id="tile-dialog-title">
        {{ tileData().title }}
    </h2>
    <button
        type="button"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'accessibility.close-dialog' | translate"
        (click)="closeDialog()"
    ></button>
</div>
<div class="modal-body px-6 py-5">
    <div
        class="text-base text-text-primary leading-6 break-words [overflow-wrap:anywhere] [&_a]:text-action-primary [&_a]:underline [&_li]:ml-6 [&_li]:list-item [&_ol]:list-decimal [&_p]:mb-3 [&_ul]:list-disc"
        [innerHTML]="tileData().content"
    ></div>
</div>
<div class="modal-footer border-t border-solid border-base-2 px-6 py-4">
    @if (tileData().canDownload) {
        <button
            class="btn btn-primary mr-2"
            type="button"
            [attr.aria-label]="'accessibility.download-tile' | translate: { title: tileData().title }"
            (click)="downloadFile()"
        >
            <i aria-hidden="true" class="icon element-download"></i>
            <span>{{ 'download' | translate }}</span>
        </button>
    }
    @if (isAdmin()) {
        <button
            class="btn btn-primary mr-2"
            type="button"
            [attr.aria-label]="'accessibility.edit-tile' | translate: { title: tileData().title }"
            (click)="editTile()"
        >
            <i aria-hidden="true" class="icon element-edit"></i>
            <span>{{ 'tileDialog.title.edit' | translate }}</span>
        </button>
    }
    <button
        class="btn btn-primary"
        type="button"
        [attr.aria-label]="'accessibility.close' | translate"
        (click)="closeDialog()"
    >
        {{ 'accessibility.close' | translate }}
    </button>
</div>
